import type { ThreadLive, ThreadSummary } from "@nabla/api";

export function standing(thread: ThreadSummary, live: ThreadLive | undefined): ThreadSummary {
  if (live === undefined) return thread;
  if (thread.state === "na-fila") {
    if (live.state === "na-fila") return live.queuePosition === thread.queuePosition ? thread : { ...thread, queuePosition: live.queuePosition };
    const { queuePosition: _, ...rest } = thread;
    return { ...rest, state: "pensando" };
  }
  if (thread.state !== "pensando" || live.state === "pensando") return thread;
  return { ...thread, state: "na-fila", queuePosition: live.queuePosition };
}
